import bankHolidays from './bank-holidays.json' with { type: "json" };

var thisYear = (new Date).getFullYear();
var thisMonth = (new Date).getMonth() + 1;

var futureBankHolidayDates = bankHolidays['england-and-wales'].events
        .filter(({date}) => {

            var year = parseInt(date.substr(0, 4));
            var month = parseInt(date.substr(5, 2));

            var inFuture = thisYear < year;
            var inThisYear = thisYear === year && thisMonth <= month;

            return inFuture || inThisYear;
        })
        .map(bankHoliday => bankHoliday.date);

var MONDAY = 1,
    TUESDAY = 2,
    WEDNESDAY = 3,
    THURSDAY = 4,
    FRIDAY = 5,
    SATURDAY = 6,
    SUNDAY = 0,
    CUT_OFF = 13,
    days,
    hours,
    minutes;

var options = { weekday: 'long', month: 'long', day: 'numeric' };

//export default createTheTimer;

function inStock() {
    var isInStock = document.getElementsByClassName('atc-button--text')[0].textContent.toLowerCase().includes('add to cart');

    return isInStock ? true : false;
}

function showTemplate() {

    var deliveryTime = nextWorkingDay();

    let day = amountOfDays(deliveryTime);
    let timeToOrder = timeToDispatch(deliveryTime);
    var content = `
    Dispatched <strong>${day}</strong><br>
    If you order within ${timeToOrder} <a href="/pages/delivery-information">Details</a>
    `;
    var template = `
    <section id="delivery-timer" class="time-to-dispatch">
       ${content}
    </section>
    `;

    let element = document.querySelector('#delivery-timer');
  
    !element ? $('.ordering-info').before(template) : element.innerHTML = content;

    // return Promise.resolve();
}

function timeToDispatch(deliveryTime) {

    let milliseconds = Math.abs(deliveryTime - new Date);

    days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));

    milliseconds -= (days * (1000 * 60 * 60 * 24));

    hours = Math.floor(milliseconds / (1000 * 60 * 60));

    milliseconds -= (hours * (1000 * 60 * 60));

    minutes = Math.floor(milliseconds / (1000 * 60));

    minutes = Math.floor(minutes/5)*5;

    let message = !days ? '' : `${days} days`;

    !!hours && (message += ` ${hours}hrs`);
    !!minutes && (message += ` ${minutes}mins`);
    return `${message}.`;
}

function amountOfDays(deliveryTime) {

    let today = new Date;

    today.setHours(CUT_OFF);
    let milliseconds = Math.abs(deliveryTime - today);
    let amountOfDays = Math.round(milliseconds / 24 / 60 / 60 / 1000);

    let text = '';

    amountOfDays == 0 && (text = 'Today');
    amountOfDays == 1 && (text = 'Tomorrow');
    amountOfDays > 1 && (text = deliveryTime.toLocaleDateString("en-GB", options));

    return text;
}

function nextWorkingDay() {

    var workingDay = canItGoToday() ? new Date : getNextWorkingDay();

    workingDay.setHours(CUT_OFF);
    workingDay.setMinutes(0);
    workingDay.setSeconds(0);
    workingDay.setMilliseconds(0);

    return workingDay;
}

function getNextWorkingDay(today = new Date()) {

    var workingDay = new Date(today.getTime());
    var day = (today).getDay();

    var dayMaps = {
        [FRIDAY]: 3,
        [SATURDAY]: 2
    };

    var amountOfDays = dayMaps.hasOwnProperty(day) ? dayMaps[day] : 1;

    workingDay.setTime(workingDay.getTime() + (amountOfDays * (1000 * 60 * 60 * 24)));

    var dateString = workingDay.toISOString().slice(0, 10);
    var isBankHoliday = futureBankHolidayDates.includes(dateString);

    return !isBankHoliday ? workingDay : getNextWorkingDay(workingDay);
}

function canItGoToday() {

    var date = new Date()

    var dateString = date.toISOString().slice(0, 10);
    var today = date.getDay(),
        hour = date.getHours();

    var workingDay = [MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY].includes(today);
    var bankHoliday = futureBankHolidayDates.includes(dateString);
    var beforeCutOff = hour < CUT_OFF;

    return workingDay && beforeCutOff && !bankHoliday;

}


document.addEventListener("DOMContentLoaded", function(event) { 
  var waitForJQuery = setInterval(function () {
      if (typeof $ != 'undefined') {
        if(inStock() == true) {
          showTemplate();
          var run = setInterval(showTemplate, 300000);
        }
          clearInterval(waitForJQuery);
      }
    }, 10);
});





